// @flow

import React, { Component } from "react"
import { connect } from "react-redux"
import ReduxToastr, { toastr } from "react-redux-toastr"
import Input from "react-toolbox/lib/input/Input"
import Button from "react-toolbox/lib/button/Button"
import { changePassword } from "../../actions"
import Card from "../../components/Card"
import styles from "./style.css"
import * as strings from "../../strings"


class PasswordRecovery extends Component {

  props: {
    history: {
      changePassword: ( password: string, recoverToken: string ) => any,
      push: () => any,
    }
  }

  state = {
    email: "",
    password: "",
    repassword: "",
    error: "",
    recoverToken: "",
  };

  handleChange = field => value => this.setState( {
    [ field ]: value,
  } )

  submit = event => {
    event.preventDefault()
    const { password, repassword, recoverToken } = this.state
    if ( password !== repassword ) {
      this.setState( {
        error: strings.recoverPassword.passDontMatch,
      } )
      return
    }

    changePassword( password, recoverToken ).then(
      ( ( result ) => {
        if ( result.message === "OK" ) {
          toastr.success( strings.recoverPassword.passChanged )
          this.cancelRequest()
        } else {
          toastr.error( strings.recoverPassword.changePassError )
        }
      } ).bind( this ) )
  }

  cancelRequest = () => {
    this.props.history.push( "/" )
  }

  componentWillMount () {
    const TOKEN_LENGTH = 64
    const url = window.location.href
    const token = url.substr( url.indexOf( "?" ) + 1 )

    if ( token.length !== TOKEN_LENGTH ) {
      this.cancelRequest()
    }
    this.setState( {
      recoverToken: token,
    } )
  }

  render () {

    const backgroundUrl = process.env.PUBLIC_URL + "/assets/img/login_background.png"

    const { password, repassword, error } = this.state

    return (
      <div
        style={{
          background: "url(" + backgroundUrl + ") no-repeat center center fixed",
          backgroundSize: "cover",
        }}
        className={styles.wrapper}
      >
        <Card>
          <form
            autoComplete="off"
            onSubmit={this.submit}
            className={styles.resetPasswordBox}
          >
            <div className={styles.logo}>
              <b>Private</b> Lawyers
            </div>
            <div className={styles.title}>
              Repor Password
            </div>
            <Input
              type="password"
              label={strings.generalStrings.password}
              icon="lock_outline"
              value={password}
              onChange={this.handleChange( "password" )}
            />
            <Input
              type="password"
              label={strings.generalStrings.confirmPassword}
              icon="lock_outline"
              value={repassword}
              onChange={this.handleChange( "repassword" )}
            />
            <div className={styles.statusMessage}>
              {error}
            </div>
            <div className={styles.buttonRow}>
              <Button
                raised
                primary
                label={strings.generalStrings.cancel}
                onClick={this.cancelRequest}
              />

              <Button
                raised
                primary
                label={strings.recoverPassword.changePass}
                onClick={this.submit}
              />


            </div>
          </form>
        </Card>
        <ReduxToastr
          timeOut={4000}
          newestOnTop={false}
          preventDuplicates
          position="top-left"
          transitionIn="fadeIn"
          transitionOut="fadeOut"
          progressBar
        />
      </div>
    )
  }
}

export default connect( store => ( { auth: store.auth } ), { changePassword } )( PasswordRecovery )



// WEBPACK FOOTER //
// ./src/views/PasswordRecovery/index.jsx